import { makeStyles } from '@material-ui/core';

// EverDriven wordmark. Paths are copied verbatim from the brand SVG at
// https://www.everdriven.com/wp-content/uploads/2026/05/everdriven-logo.svg
// (viewBox 0 0 1000 206). The 10 letter paths are rendered white for legibility
// on the navy #003459 sidebar (white is 12.84:1 on the navy). The 2 pin paths
// (the marker starting "M724.265 0..." and the inner dot starting
// "M716.864 48.4908...") keep the pin's original brand blue #3675B1 so the
// location-pin graphic reads as brand, not as a white letter.
const useStyles = makeStyles({
  svg: {
    width: 'auto',
    height: 30,
  },
});

const LogoFull = () => {
  const classes = useStyles();

  return (
    <svg
      className={classes.svg}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 1000 206"
      fill="none"
    >
      <path
        d="M446.7 205.258C403.832 201.606 387.217 148.468 410.271 115.736C423.418 97.0655 450.533 88.0722 471.213 99.85C472.675 100.672 473.999 101.813 475.458 102.68V51.1406H507.872V203.478H475.458L475.231 197.543C473.953 198.364 472.814 199.414 471.49 200.191C467.56 202.473 460.759 204.847 456.287 205.303C451.811 205.76 449.255 205.532 446.7 205.303V205.258ZM454.825 124.227C427.525 126.328 424.65 166.911 448.982 174.489C458.385 177.411 469.8 175.265 475.369 166.637L475.458 133.951C471.625 126.738 462.815 123.634 454.871 124.273H454.825V124.227Z"
        fill="#FFFFFF"
      />
      <path
        d="M823.78 205.258C785.342 200.83 763.658 161.479 778.953 126.054C797.897 82.2286 868.796 84.009 879.796 132.217C881.578 139.977 881.624 147.692 880.846 155.59H805.522C806.388 175.448 832.683 181.748 846.149 169.513C848.617 167.276 849.802 164.309 852.223 162.483L877.013 179.283C877.606 180.424 872.171 186.769 871.032 187.956C861.856 197.589 848.343 203.98 835.011 204.847L834.284 205.258H823.78ZM849.348 136.827C845.83 114.504 809.905 115.463 805.522 136.827H849.348Z"
        fill="#FFFFFF"
      />
      <path
        d="M1000 141.829V203.412H967.589C967.358 183.599 968.136 163.696 967.131 143.883C964.21 120.784 942.845 118.592 928.328 133.383V203.412H895.913V96.2233H928.328V102.614C939.466 94.3063 953.664 92.9365 966.95 96.1779C987.811 101.291 999.542 119.871 999.499 140.733L999.954 141.829H1000Z"
        fill="#FFFFFF"
      />
      <path
        d="M724.265 0C764.165 2.9673 793.243 38.2098 787.581 78.1086C787.127 81.4412 785.938 84.728 785.437 88.0606H748.458C761.836 68.8871 752.888 41.8617 730.427 35.1511C703.035 26.9797 678.156 53.0461 687.832 79.9802C688.883 82.9476 690.48 85.2757 691.804 88.0606H655.514C650.125 73.4066 651.495 56.3333 657.338 41.9988C667.106 18.1234 690.711 1.64343 716.455 0H724.265Z"
        fill="#3675B1"
      />
      <path
        d="M264.552 205.249C224.881 202.51 202.511 160.42 219.402 124.812C238.896 83.7722 300.525 83.9092 313.81 129.332C315.819 136.134 316.458 143.027 317.051 150.057H226.205C226.113 190.915 272.724 207.806 301.758 181.1L309.291 189.728C307.19 190.778 305.547 192.741 303.493 194.202C294.773 200.41 283.817 204.428 273.043 204.793L272.313 205.203H264.552V205.249ZM303.356 139.101C302.625 124.219 292.399 111.574 278.156 107.511C254.097 100.617 231.865 115.043 227.117 139.101H303.356Z"
        fill="#FFFFFF"
      />
      <path
        d="M50.4431 205.235C-21.1845 200.077 -14.6106 89.5102 57.9756 94.8515C87.0101 96.9971 103.171 122.698 102.486 150.043H12.0956C11.6391 191.038 58.6603 207.746 87.6036 181.086L94.5426 188.801C95.1818 190.034 90.8446 193.001 89.8863 193.731C80.984 200.305 69.2972 204.414 58.2496 205.235H50.4431ZM89.247 139.087C86.1884 101.562 35.9714 93.8927 17.9391 125.575C15.5652 129.729 13.7391 134.385 13.0086 139.087H89.247Z"
        fill="#FFFFFF"
      />
      <path
        d="M694.821 95.332L719.93 141.85L745.267 95.332H782.7L720.615 203.89L658.072 95.332H694.821Z"
        fill="#FFFFFF"
      />
      <path
        d="M599.634 96.2315V129.967C588.222 124.398 573.431 124.9 563.571 133.391V203.419H531.156V96.2315H563.571V105.361C572.608 94.8163 586.579 92.4878 599.634 96.2315Z"
        fill="#FFFFFF"
      />
      <path
        d="M647.568 96.2383H615.153V203.426H647.568V96.2383Z"
        fill="#FFFFFF"
      />
      <path
        d="M198.356 96.2188H212.052L158.183 204.776L103.857 96.2188H116.868L157.954 179.212L198.356 96.2188Z"
        fill="#FFFFFF"
      />
      <path
        d="M392.834 96.2278V108.553C378.453 105.495 363.798 111.11 356.403 123.938C355.901 124.759 353.572 129.279 353.572 129.781V203.462H341.703V96.2732H353.572V112.251C357.59 108.051 361.059 103.851 366.218 100.93C374.298 96.319 383.611 94.9492 392.834 96.2732V96.2278Z"
        fill="#FFFFFF"
      />
      <path
        d="M716.864 48.4908C737.909 45.6604 748.64 71.1794 732.248 83.9617C721.841 92.0417 705.907 87.3397 701.527 74.9684C697.143 62.5971 704.721 50.1342 716.818 48.4908H716.864Z"
        fill="#3675B1"
      />
    </svg>
  );
};

export default LogoFull;
